var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full flex justify-center",class:{'items-center': _vm.fullWidth}},[_c('div',{class:{'relative overflow-hidden': _vm.blurOn, 'opacity-0': !_vm.elW},style:(_vm.style)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }